export default __webpack_public_path__ + "locales/ar-SA/DeleteDialog.json?hash=b4ac98d31d44a3d6277e76cffb42d3e3";